import api from "@/api/api-v2-config";

export async function getAttendanceListAxios({id, date, currentEmployee, pageNumber = 1, pageSize = 10000}) { 
    let params = (id) ? `id=${id}` : '';
    params += (date) ? `${params ? '&': ''}date=${date}` : '';
    params += (currentEmployee) ? `${params ? '&': ''}currentEmployee=${currentEmployee}` : '';

    let url = params ? `hrms/attendance?${params}&PageNumber=${pageNumber}&PageSize=${pageSize}` : `hrms/attendance?&PageNumber=${pageNumber}&PageSize=${pageSize}`;
    return await api.get(url);
}

export async function postAttendanceAxios(attendance) {    
    return await api.post("hrms/attendanceextended", attendance);
}

export async function putAttendanceAxios(attendance) {    
    return await api.put("hrms/attendance", attendance);
}

export async function getAttendanceByIDAxios(id) {    
    return await api.get("hrms/attendance/" + id);
}

export async function postImportAttendanceAxios(payload) {    
    return await api.post("uploads/importattendance", payload);
}